// extracted by mini-css-extract-plugin
export default {"playersNumber":"GameLivePlayersNumber__playersNumber--dpR","gameFavoriteIcon":"GameLivePlayersNumber__gameFavoriteIcon--10W"};